export const educationData = [
    {
        id: 1,
        institution: 'Govt. M.M Ali College',
        course: 'Higher Secondary Education',
        startYear: '2016',
        endYear: '2019'
    },
    {
        id: 2,
        institution: 'Green University Of Bangladesh',
        course: 'Bachelor of Computer Science And Engineering',
        startYear: '2020',
        endYear: 'Running'
    },
    // {
    //     id: 3,
    //     institution: 'Hawking University, Cambridge',
    //     course: 'Master of Technology',
    //     startYear: '2019',
    //     endYear: 'Present'
    // },
]